// extracted by mini-css-extract-plugin
export default {"tabHeader":"TabHeader_tabHeader__8aeAk","active":"TabHeader_active__a5GuJ"};